import { datadogLogs, HandlerType, Logger, StatusType } from "@datadog/browser-logs";

import isDev from "../isDev";
import isTest from "../isTest";
import ignoreMessage from "./ignoreMessage";

let logger: Logger | undefined;

if (!isTest()) {
  datadogLogs.onReady(function () {
    logger = datadogLogs.logger;

    const handlers: HandlerType[] = [HandlerType.http];

    if (isDev()) {
      // We always want to see them for local development
      handlers.push(HandlerType.console);
    }

    logger.setHandler(handlers);

    // Log everything, from lowest level
    logger.setLevel(StatusType.debug);
  });
}

// This ensures we always have an error object to pass on further if possible
function downcastErrorFromMessage(message: unknown, originalError?: unknown) {
  if (!originalError && message instanceof Error) {
    return message;
  } else if (originalError instanceof Error) {
    return originalError;
  }

  return undefined;
}

const debug = (message: unknown, messageContext?: object, originalError?: unknown) => {
  if (ignoreMessage(message)) return;

  const error = downcastErrorFromMessage(message, originalError);
  logger?.debug(String(message), messageContext, error);
};

const info = (message: unknown, messageContext?: object, originalError?: unknown) => {
  if (ignoreMessage(message)) return;

  const error = downcastErrorFromMessage(message, originalError);
  logger?.info(String(message), messageContext, error);
};

const warn = (message: unknown, messageContext?: object, originalError?: unknown) => {
  if (ignoreMessage(message)) return;

  const error = downcastErrorFromMessage(message, originalError);
  logger?.warn(String(message), messageContext, error);
};

const error = (message: unknown, messageContext?: object, originalError?: unknown) => {
  if (ignoreMessage(message)) return;

  const error = downcastErrorFromMessage(message, originalError);
  logger?.error(String(message), messageContext, error);
};

export default {
  debug,
  info,
  warn,
  error,
};
